<template>
  <b-row>
    <b-row class="row content" style="margin: 0;right: 0; min-height: calc(100vh - 80px)">
      <b-col md="6" xs="12" style="margin-top: 50px">
        <b-img class="img img-responsive" fluid src="../assets/images/anasayfa2.png"/>
      </b-col>
      <b-col md="5" xs="12" style="padding-bottom: 30px">
        <div class="header text-center">
          <h1 class="mor">YDS YÖKDİL SINAV ANALİZ SAYFASI</h1>
          <h2>Ankara Dil Akademisi YDS YÖKDİL Sınav Analiz Sayfası</h2>
          <p class="mor"> Sınav sonrası yanlışlarınızı belirleyin</p>
          <p class="mor"> Yanlış yaptığınız soruların video çözümlerini izleyerek, eksiklerinizi öğrenin</p>
          <p class="mor"> Hangi Ankara Dil Akademisi eğitiminin sizi başarıya ulaştıracağını öğrenin. Gerekirse öğretmenlerinizden, geridönüşler alın.</p>
<!--          <p class="mor"> Bu değerlendirme sayfasına sadece Ankara Dil Akademisi aktif öğrencileri ve öğretmenlerden aktivasyon kodu almış öğrenciler ulaşabilirler.</p>-->
<!--          <b-button  v-show="!loggedin" style="color:white" to="login" variant="success">Giriş Yapın</b-button>-->
          <p   v-show="!loggedin" class="mor">Sisteme giriş yapabilmek için <a :href="casdoor.getSigninUrl()"> Üye Girişi / Üye Ol </a> bağlantısını kullanabilirsiniz. </p>
<!--          <p   v-show="!loggedin" class="mor">Sisteme üye olmak için <a :href="casdoor.getSignupUrl()">  Üye Ol </a> bağlantısını kullanabilirsiniz. </p>-->
          <b-button  v-show="loggedin" style="color:white" to="Sinavlarim" variant="success">Sınavları Görün</b-button>
<!--          <b-button style="color:white" to="eyds-hazirlik-kamp-programlari" variant="primary">E-YDS Kamp Programlarımızı İnceleyin</b-button>-->
        </div>
      </b-col>
    </b-row>
    <b-container class="footer text-center"><a href="https://www.ankaradil.com" target="_blank"> Ankara Dil Akademisi </a> için <a href="http://code4edu.com" target="_blank"> code4edu.com  </a> tarafından hazırlanmıştır.</b-container>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import Sdk from 'casdoor-js-sdk'

const config = {
  serverUrl: 'https://doorapi.ankaradil.com',
  clientId: '7a5376c2a76da60a2e0c',
  organizationName: 'root',
  appName: 'AnkaradilV2',
  redirectPath: '/callback'
}
var casdoor = new Sdk(config)
export default {
  name: 'AnaSayfa',
  data () {
    return {
      msg: '',
      casdoor: casdoor
    }
  },
  computed: {
    ...mapState([
      'loggedin',
      'user'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.header{
  margin-top: 25%;
}
.mor{
  color:#7c7cb0
}
.footer {
  /*position: absolute;*/
  width: 100%;
  height: 80px
}
.content{

}
</style>



// WEBPACK FOOTER //
// src/components/AnaSayfa.vue